<template>
  <div v-if="uiStore.activePanel === 'history'" class="stamp_wrapper history">
    <div class="block_stamp">
      <p class="deco-ti">履歴から画像を選択</p>
      <a class="btn_back" href="#" @click.prevent="uiStore.hidePanel()">
        <img src="/img/back_b.png">
      </a>
      <div class="histry-box">
        <ul class="box_stamp cf">
          <li v-for="pic in decoDataStore.pictures" :key="pic.id">
            <img
              :src="'/api/deco/picture/' + pic.id"
              class="img_history"
              @click="onSelect(pic)"
              loading="lazy"
            />
          </li>
          <li v-if="decoDataStore.pictures.length === 0">
            <span>履歴がありません</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useDecoDataStore } from '../../stores/useDecoDataStore'
import { useCanvasStore } from '../../stores/useCanvasStore'
import { useUiStore } from '../../stores/useUiStore'
import { loadImage } from '../../composables/useImageLoader'

const decoDataStore = useDecoDataStore()
const canvasStore = useCanvasStore()
const uiStore = useUiStore()

async function onSelect(pic) {
  uiStore.setLoading(true)
  try {
    const url = '/api/deco/picture/' + pic.id
    const img = await loadImage(url)
    const size = canvasStore.canvasSize
    const ratio = img.naturalWidth / img.naturalHeight
    const max = size * 0.6
    const w = ratio >= 1 ? max : max * ratio
    const h = ratio >= 1 ? max / ratio : max
    canvasStore.addObject({
      objectType: 'picture',
      src: url,
      x: canvasStore.labelCenterX,
      y: canvasStore.labelCenterY,
      width: w,
      height: h,
      rotation: 0,
    })
    uiStore.hidePanel()
  } finally {
    uiStore.setLoading(false)
  }
}
</script>
